// Modules
import { upcomingMatchesSliderInit } from './modules/upcoming-matches-slider';


window.addEventListener('DOMContentLoaded', () => {
  upcomingMatchesSliderInit();
});